// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Curry = require("rescript/lib/js/curry.js");

var React = require("react");

var Slate$AnchorFrontend = require("./bindings/Slate.bs.js");

function RichTextEditor_Element(Props) {
  var attributes = Props.attributes;
  var element = Props.element;
  var children = Props.children;

  var typ = Curry._1(Slate$AnchorFrontend.$$Element.typ, element);

  var match = typ === "a" ? ["a", _objectSpread(_objectSpread({}, attributes), {}, {
    href: element.url
  })] : [Curry._1(Slate$AnchorFrontend.$$Element.typToJs, typ), attributes];
  return React.createElement(match[0], match[1], children);
}

var make = RichTextEditor_Element;
exports.make = make;
/* react Not a pure module */